import { useCallback, useEffect, useRef } from 'react'

// リアルタイムに伸びるコンテナ (文字起こしストリーム等) を 「最下部追従」 させる小型 hook.
// ユーザが手動で上にスクロールしている間は追従を一時停止し、 再度最下部付近へ戻ったら追従を再開する.
//
// 使い方:
//   const { ref, onScroll } = useStickToBottom([finalsCount, interimText])
//   <Box ref={ref} onScroll={onScroll} sx={{ overflow: 'auto', maxHeight: 240 }}>...</Box>
//
// dep に渡した値が変わるたびに 「追従中なら最下部へスクロール」 を試みる.
const STICK_THRESHOLD_PX = 32

export const useStickToBottom = <T extends HTMLElement = HTMLDivElement>(
  trigger: React.DependencyList
) => {
  const ref = useRef<T | null>(null)
  const stickRef = useRef(true)

  const onScroll = useCallback((e: React.UIEvent<T>) => {
    const el = e.currentTarget
    const distFromBottom = el.scrollHeight - (el.scrollTop + el.clientHeight)
    stickRef.current = distFromBottom < STICK_THRESHOLD_PX
  }, [])

  useEffect(() => {
    const el = ref.current
    if (!el || !stickRef.current) return
    el.scrollTop = el.scrollHeight
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, trigger)

  return { ref, onScroll }
}
